<template>
  <div id="Authentication">
    <div class="content1">
      <p class="title">委托录入记录</p>
      <p class="line-gray"></p>
      <el-form ref="form" :model="form" class="rzForm">
        <el-form-item label="信息读取状态：">
          <el-radio-group v-model="form.isRead">
            <el-radio label="" value="">全部</el-radio>
            <el-radio label="0" value="0">未被读</el-radio>
            <el-radio label="1" value="1">已被读</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="纳税人名称：">
          <el-input size="small" placeholder="请输入纳税人名称" class="input-rz" v-model="form.nsrmc"></el-input>
        </el-form-item>
        <el-form-item label="项目名称：">
          <el-input size="small" placeholder="请输入项目名称" class="input-rz" v-model="form.xmmc"></el-input>
        </el-form-item>
        <el-form-item label="税务机关：">
          <!--<el-select size="small" class="input-rz" v-model="form.zzdj" placeholder="请选择">
            <el-option label="" value="">请选择</el-option>
            <el-option label="A级" value="1"></el-option>
            <el-option label="AA级" value="2"></el-option>
            <el-option label="AAA级" value="3"></el-option>
            <el-option label="AAAA级" value="4"></el-option>
            <el-option label="AAAAA级" value="5"></el-option>
          </el-select>-->
          <SelectTree
            :props="props"
            :options="list"
            :value="valueId"
            :clearable="isClearable"
            :accordion="isAccordion"
            @getValue="getValue($event)"/>
        </el-form-item>
        <el-form-item label="委托人联系方式：">
          <el-input size="small" placeholder="请输入" class="input-rz" v-model="form.phonenumber"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button size="small" class="rzSearch" type="warning" @click="searchSubmit(1)">查询</el-button>
        </el-form-item>
      </el-form>
      <div class="rzData">
        <template>
          <el-table
            :data="tableData"
            v-loading="loading"
            height="100%"
            header-row-class-name="head-center"
            border
            style="width: 100%">
            <el-table-column
              type="index"
              align="center"
              label="序号"
              width="50">
            </el-table-column>
            <el-table-column
              prop="nsrmc"
              label="纳税人名称"
              :show-overflow-tooltip="true"
              width="140">
              <!--<template slot-scope="scope">
                <el-popover trigger="hover" placement="top">
                  <p>手机号: {{ scope.row.nsrmc }}</p>
                  <div slot="reference" class="name-wrapper text-over">
                    {{ scope.row.nsrmc }}
                  </div>
                </el-popover>
              </template>-->
            </el-table-column>
            <el-table-column
              prop="nsrsbh"
              label="纳税人识别号"
              align="center"
              width="170"
            >
            </el-table-column>
            <el-table-column
              prop="xmmc"
              label="委托项目名称"
              width="160"
              :show-overflow-tooltip="true">
            </el-table-column>
            <el-table-column
              prop="swjg"
              label="主管税务机关"
              align="center"
              :show-overflow-tooltip="true"
              width="140"
            >
            </el-table-column>
            <el-table-column
              prop="xmid"
              label="项目编号"
              width="116"
              :show-overflow-tooltip="true">
            </el-table-column>
            <el-table-column
              prop="xmdz"
              label="项目地址"
              width="150"
              align="center"
              :show-overflow-tooltip="true">
            </el-table-column>
            <el-table-column
              prop="username"
              label="委托账号"
              width="180"
              align="center"
              :show-overflow-tooltip="true">
            </el-table-column>
            <el-table-column
              prop="insert_date"
              width="100"
              label="委托日期"
              :show-overflow-tooltip="true">
            </el-table-column>
            <el-table-column
              prop="zsxm"
              label="委托人"
              align="center"
              :show-overflow-tooltip="true">

            </el-table-column>
            <el-table-column
              prop="phonenumber"
              label="委托人联系方式"
              width="135"
              :show-overflow-tooltip="true">
            </el-table-column>
            <el-table-column
              prop="readnumber"
              label="已读数"
              width="70"
              :show-overflow-tooltip="true">
            </el-table-column>
            <el-table-column
              prop="readlist"
              align="center"
              label="已读人"
              width="125"
              :show-overflow-tooltip="true">

            </el-table-column>
          </el-table>
        </template>

      </div>
      <div class="rzPage">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[1,10, 20, 30, 40,50,60,70,80,90,100]"
          :page-size="form.pagesize"
          :current-page.sync="form.pageindex"
          :pager-count="5"
          layout="prev, pager, next, total,sizes, jumper"
          :total="form.pageNum">
        </el-pagination>
      </div>
    </div>
    <div class="images none" v-viewer="{movable: false}">
      <img v-for="src in images" :src="src.path" v-bind:key="src.id">
    </div>
  </div>

</template>


<script>
  import SelectTree from "./treeSelect.vue";
  import 'element-ui/lib/theme-chalk/index.css';
  export default {
    name: 'Applylist',
    data () {
      return {
        images:[
        ],
        urljump:this.$store.getters.getUrl,
        loginUrl:this.$store.getters.getloginUrl,
        // 查询条件
        form: {
          nsrmc:'',
          xmmc:'',
          nsrsbh:'',
          phonenumber:'',
          sqlx:'',
          swjgdm:'',
          zzdj:'',
          isRead:'',
          pagesize:50,
          pageindex:1,//
          pageNum:0
        },
        curData:{//当前操作行数据
          MaxProjectCount:''
        },
        tableData: [],
        loading: true,
        isClearable:true,     // 可清空（可选）
        isAccordion:true,     // 可收起（可选）
        valueId:0,            // 初始ID（可选）
        props:{               // 配置项（必选）
          value: 'id',
          label: 'title',
          children: 'children',
          // disabled:true
        },
        // 选项列表（必选）
        list:[

        ]
      }
    }
    , methods: {
      // 取值
      getValue(value){
        this.valueId = value
        this.form.swjgdm = value
        console.log(this.valueId);
      },

      // 查询提交
      searchSubmit:function(num){
        if(num!==undefined){
          this.form.pageindex = num;
        }
        var that = this;
        that.loading = true;
        console.log(this.form);
        let params = this.form;
        this.$axios({
          method: 'post',
          url: 'UserManager/GetWeiTuoList_FY',
          data: params
        })
          .then(res => {
            let data = res.data
            console.log(data)
            try{
              var pageNum = data.result.ds1[0].number;
              that.form.pageNum = pageNum;
              console.log('分页数：'+pageNum);
            }catch(e){

            }

            if (data.isError === 'False') {
              var result =  data.result.ds;
              for (let i = 0; i < result.length; i++) {
                result[i].insert_date = result[i].insert_date.split('T')[0]
              }
              that.tableData = result;
            } else {
              that.tableData = [];
            }
            that.loading = false;
          })
          .catch(err => {
            that.$message.error('网络连接失败');
            // window.location.href = that.$store.getters.getloginUrl
          })
      },
      handleSizeChange:function(val) {
        console.log(`每页 ${val} 条`);
        this.form.pagesize = val;
        this.searchSubmit();
      },
      handleCurrentChange:function(val) {
        console.log(`当前页: ${val}`);
        this.form.pageindex = val;
        this.searchSubmit();
      },
      // 税务机关树
      getTrees:function(data){
        this.list = fn(data.result,0)
        // console.log(this.list)
        function fn(data, pid) {
          var result = [], temp;
          for (var i = 0; i < data.length; i++) {
            if (data[i].Pcode == pid) {
              var obj = {"title": data[i].oname,"id": parseInt(data[i].Ocode),"parentId":parseInt(data[i].Pcode)};
              temp = fn(data, data[i].Ocode);
              if (temp.length > 0) {
                obj.children = temp;
              }
              result.push(obj);
            }
          }
          return result;
        }
      },
      //请求税务机关
      getSwjg:function(code){
        //GetSwjgListByOcode(string pcode, int level1 = 0, int level2 = 1)
        let params = {
          'pcode':code,
          'level1':0,
          'level2':20
        }
        var that = this;
        this.$axios({
          method: 'post',
          url: 'UserManager/GetSwjgListByOcode',
          data: params
        })
          .then(res => {
            let data = res.data
            console.log(data)
            if (data.isError == 'False') {
              that.getTrees(data)
            } else {
              that.$message.error(data.errorMessage);
            }

          })
          .catch(err => {
            that.$message.error('网络连接失败');
            window.location.href = that.$store.getters.getloginUrl
          })
      }
    }
    , watch: {
    },
    mounted:function(){
      var loginUser = this.$route.query.name;
      this.$store.getters.getLoginUser1.name = loginUser;
    }
    , created () {
      this.getSwjg(0);
      this.searchSubmit();
    },
    components: {
      SelectTree
    },
  }
</script>

<style scoped>
  div{ overflow: inherit;}
  .width80{ width: 100%; min-width: 200px;}
  .head-center th,.html-center{ text-align: center;}
  .Brand{ color:#0779FF;}
  .Success{ color:#67C23A;}
  .Warning{ color:#E6A23C;}
  .Danger{ color:#F56C6C;}
  .content {

  }
  .content1 {
    width: 100%;
    background-color: #fff;
    height:calc(100% - 20px) !important;
    min-width: 1190px;
    max-width: 1200px;
    margin: 10px auto;
    overflow-x:hidden ;
  }
  #Authentication{ height:calc(100% - 235px); margin: auto; width: 100%;}
  #Authentication p{ padding: 0px; margin: 0px;}
  #Authentication .title {
    font-size: 24px;
    color: #2E2E2E;
    letter-spacing: 0;
    margin: 19px 0px 12px 24px;
  }

  #Authentication .title:before {
    content: '';
    position: relative;
    display: inline-block;
    font-size: 0;
    width: 6px;
    height: 20px;
    top: 2px;
    left: 0;
    margin-right: 13px;
    background: #04A4FF;
  }

  .line-gray {
    height: 1px;
    background: #EDEDED;
    margin: 0 24px;
  }
  .rzData .el-form-item,.rzForm .el-form-item{ display: inline-flex; margin-right: 12px; margin-bottom: 0px;} /*margin: auto !important;*/
  .rzForm .input-rz{
    width: 100px;
  }
  .rzForm .input-rz input{ padding: 0 10px !important;}
  .rzForm .el-form-item{ margin-bottom: 0px;}
  .rzForm .el-form-item label{ padding: 0px !important;font-size: 12px;}
  .rzForm .el-radio{ margin-right: 10px !important;}
  .rzForm .el-radio__label{ padding-left: 5px;}
  .rzForm{ padding-left: 25px;}
  .rzSearch{ width: 72px;}
  .rzData{ padding: 0px 25px; height:calc(100% - 172px);}
  >>>.rzData .el-table th,>>>.rzData thead .el-table tr{background: #F9FBFF;color: #2E2E2E; font-weight: normal;
  }
  #Authentication .text-over{ white-space: nowrap; overflow: hidden; text-overflow: ellipsis; width: 100%;}
  >>> .rzData .el-table td,>>>.rzData .el-table th{padding: 5px 0px;}
  #Authentication .el-message-box__title,.rzData .el-dialog__title{font-size: 14px;
    color: #929AAB;}
  #Authentication .el-message-box__header,.rzData .el-dialog__header{border-bottom: 1px solid #E2E2E2;}
  #Authentication  .el-message-box__btns{ text-align: center;}
  .rzData .el-form-item__content{ margin-left: 0px !important; min-width: 200px;}
  .days .el-form-item__content{min-width: 80px;}
  .rzData .dialog-footer{ text-align:center;}
  .rzData .el-form-item__label,.rzData .el-input__inner,.rzData .el-form-item__content,.rzData .el-input__icon{ height: 32px; line-height: 32px;}
  .rzData .el-dialog__header{ padding: 10px 20px;}
  .rzData .el-dialog__headerbtn{top:15px;}
  .rzPage{border: 1px solid #EBEEF5; margin: 0px 25px; border-top:none; padding: 5px 0px;}
  #Authentication .el-dialog{ height:auto; padding-bottom: 15px; max-width: 600px;}
  #Authentication .el-dialog__body{padding: 30px 20px !important;}
  >>> .el-form-item__label{ padding: 0px !important;}
</style>



// WEBPACK FOOTER //
// src/components/Applylist.vue